import {
  NO_CONFIG_ENDPOINT, NO_SESSION_ENDPOINT, NO_ALERTS_ENDPOINT,
  EuAppFeatureFlags
} from '@eucoms/common-components';

import { Constants } from '@config/constants/constants.interface';
import { commonConstants } from '@config/constants/common';
import { constantsPattern as defaults } from './defaults';

const featureFlagsCommon: EuAppFeatureFlags = {
  common: {
    AccountsPrepaidBanner: true,
    ActiveAlertsSource: true,
    AlternateRegistration: true,
    NewBusiness: true,
    NewBusinessSiteReady: true,
    NewChangeAccount: true,
    NewLogin: true,
    PayArrangeExtended: true,
    PaymentRegistration: true,
    RegistrationFeedback: true,
    IsOutageTracker: true
  }
};

export const featureFlags: any = featureFlagsCommon.common;

/**
 * This is the configuration file for runtime constants for use with
 * `npm run dev:headless`
 *
 * project specific settings that would conflict with other projects must not
 * be simply chnages here, rather they must be moved to the dev/ folder and
 * instaniated like the proprties there (see the getBaseUrl for example, above)
 */

export const constantsPattern: Constants = {
  ...commonConstants,
  ...defaults,
  isProvidingChatBot: false,
  isProvidingGTM: false,

  devAuthHooks: ['authGuard'],

  CoreServicesInitOptions: {
    configEndpoint: NO_CONFIG_ENDPOINT,
    sessionEndpoint: NO_SESSION_ENDPOINT,
    alertsEndpoint: NO_ALERTS_ENDPOINT,

    additionalConfig: {
      common: {
          opCo: 'ComEd',
          additionalConfig: {
            common: {
              megaMenu: {
                endPoint: 'no megamenu endpoint'
              }
            }
          }
        }
    },
  },

  featureFlags
};
